import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import i18n from "i18next";
import _ from "lodash";
import { EmptyData } from "../../../../components/empty/emptyData";
import { PageHeader } from "../../../../components/page-header";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";

import { useProcessingCapacity } from "./useProcessingCapacity";
import { useLazyGetProcessingCapacityListQuery } from "../../../../redux/api/organic/processingCapacityApi";
import { EntProcessingCapacity } from "../../../../models/organic/processingCapacity";
import { EntProcessingCapacityFilter } from "../../../../models/filters/organic/processingCapacityFilter";
import { FilterProcessingCapacity } from "./FilterProcessingCapacity";
import { AddProcessingCapacityModal } from "./AddProcessingCapacity";


enum FormField {
  orgName,
  pin,
  regionId,
  areaId,
  territorialUnitId,
}

export const ProcessingCapacity = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedItem, setSelectedItem] = useState<EntProcessingCapacity>(new EntProcessingCapacity());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showReportModal, setShowReportModal] = useState<boolean>(false);
  const [form] = useForm();
  const { t } = useTranslation()

  const [getArchiveFolders] = useLazyGetProcessingCapacityListQuery();
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntProcessingCapacity, EntProcessingCapacityFilter>({
	initialFilter: new EntProcessingCapacityFilter(),
	query: getArchiveFolders
  });

  const {
	onAddProcessingCapacity,
	onDeleteProcessingCapacity,
	onEditProcessingCapacity
  } = useProcessingCapacity(modal, () => {
	searchHandleClick();
  })
  const [height, setHeight] = useState<number>(0);

  const storedData = JSON.parse(localStorage.getItem("availableRoutes") || "[]");
  const isReportAvailable = storedData.some((route: any) => (route.alias === "/report" || route.alias === "/interactive-map-ws") && route.methodPost);

  const openAddModal = (item: EntProcessingCapacity) => {
	setSelectedItem(item);
	setShowModal(true);
  }

  const setEntityFromFields = (): EntProcessingCapacityFilter => {
	let filt: EntProcessingCapacityFilter = _.clone(filter);
	filt.orgName = form.getFieldValue(FormField.orgName) ?? null;
	filt.pin = form.getFieldValue(FormField.pin) ?? null;
	filt.regionId = form.getFieldValue(FormField.regionId) ?? null;
	filt.areaId = form.getFieldValue(FormField.areaId) ?? null;
	filt.territorialUnitId = form.getFieldValue(FormField.territorialUnitId) ?? null;
	filt.page = 1;
	return filt;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.orgName, value: null },
	  { name: FormField.pin, value: null },
	  { name: FormField.regionId, value: null },
	  { name: FormField.areaId, value: null },
	  { name: FormField.territorialUnitId, value: null },
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('Наименование организации') } </th>
		  <th>{ t('ПИН организации') }</th>
		  <th>{ t('Юридический адрес') }</th>
		  <th>{ t('Контактное лицо') }</th>
		  <th>{ t('Номера телефонов') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ? (
		  <tr>
			<th colSpan={ 7 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		) : null }
		{ data.length !== 0 ? data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item.orgName }</td>
			<td>{ item.pin }</td>
			<td>{ item.legalAddress }</td>
			<td>{ item.contactPerson }</td>
			<td>{ item.phoneNumbers?.join(", ") || "" }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteProcessingCapacity(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) : (
		  <tr>
			<td colSpan={ 9 }>
			  <EmptyData/>
			</td>
		  </tr>
		) }
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('Мощности переработки') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('general.records_found') } { totalItems }
		  </Typography.Text>
		}
	  />
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntProcessingCapacity())
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={
		<FilterProcessingCapacity
		  onSearch={ searchHandleClick }
		  onReset={ () => {
			clearFields();
			searchHandleClick()
		  } }
		  formField={ FormField }
		  form={ form }
		/>
	  }
		setHeight={ setHeight }
		table={ table }
	  />

	  <AddProcessingCapacityModal
		item={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedItem.id !== null ? onEditProcessingCapacity : onAddProcessingCapacity }
	  />
	  { contextHolder }
	</>
  );
}
